import { render } from "./AppCheckbox.vue?vue&type=template&id=57ff9bd4&scoped=true&ts=true"
import script from "./AppCheckbox.vue?vue&type=script&lang=ts"
export * from "./AppCheckbox.vue?vue&type=script&lang=ts"

import "./AppCheckbox.vue?vue&type=style&index=0&id=57ff9bd4&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57ff9bd4"]])

export default __exports__